import axios from 'axios';
import Mixin from "@utilities/mixin";

export default {
    mixins: [Mixin],
    data() {
        return {
            shopId: null,
            techsOnDuty: [],
            serviceSalesTally: [
                { type: 'service', price: 300, amount: 0 },
                { type: 'service', price: 275, amount: 0 },
                { type: 'service', price: 250, amount: 0 },
                { type: 'service', price: 225, amount: 0 },
                { type: 'service', price: 200, amount: 0 },
                { type: 'service', price: 175, amount: 0 },
                { type: 'service', price: 150, amount: 0 },
                { type: 'service', price: 125, amount: 0 },
                { type: 'service', price: 100, amount: 0 },
                { type: 'service', price: 75, amount: 0 },
                { type: 'service', price: 70, amount: 0 },
                { type: 'service', price: 65, amount: 0 },
                { type: 'service', price: 60, amount: 0 },
                { type: 'service', price: 55, amount: 0 },
                { type: 'service', price: 50, amount: 0 },
                { type: 'service', price: 45, amount: 0 },
                { type: 'service', price: 40, amount: 0 },
                { type: 'service', price: 35, amount: 0 },
                { type: 'service', price: 32, amount: 0 },
                { type: 'service', price: 30, amount: 0 },
                { type: 'service', price: 25, amount: 0 },
                { type: 'service', price: 20, amount: 0 },
                { type: 'service', price: 15, amount: 0 },
            ],
            serviceTypeTally: [
                { type: 'NP', amount: 0 },
                { type: 'TT', amount: 0 },
                { type: 'IL', amount: 0 },
                { type: 'DT', amount: 0 },
                { type: 'DR', amount: 0 },
                { type: 'RW', amount: 0 },
                { type: 'ORW', amount: 0 },
                { type: 'Permit', amount: 0 },
                { type: 'PC', amount: 0 },
                { type: 'PS', amount: 0 },
                { type: 'Other', amount: 0 },
            ],
            smogSalesTally: [
                { type: 'smog', price : 0,  amount: 0 },
                { type: 'smog', price : 6,  amount: 0 },
                { type: 'smog', price : 15, amount: 0 },
                { type: 'smog', price : 17, amount: 0 },
                { type: 'smog', price : 18, amount: 0 },
                { type: 'smog', price : 19, amount: 0 },
                { type: 'smog', price : 20, amount: 0 },
                { type: 'smog', price : 25, amount: 0 },
                { type: 'smog', price : 26.99, amount: 0 },
                { type: 'smog', price : 27, amount: 0 },
                { type: 'smog', price : 29.99, amount: 0 },
                { type: 'smog', price : 35, amount: 0 },
                { type: 'smog', price : 45, amount: 0 }
            ],
            revenue: [
                {type: "ones", label: "$1", price: 1, amount: 0},
                {type: "fives", label: "$5", price: 5, amount: 0},
                {type: "tens", label: "$10", price: 10, amount: 0},
                {type: "twenties", label: "$20", price: 20, amount: 0},
                {type: "fifties", label: "$50", price: 50, amount: 0},
                {type: "hundreds", label: "$100", price: 100, amount: 0},
                {type: "coins", label: "Change", price: 1, amount: 0},
                {type: "cc", label: "CC", price: 1, amount: 0}
            ],
            totalCash: 0,
            totalCC: 0,
        };
    },
    computed: {
        transactions() {
            return this.$store.state.transactions;
        },
        totalServices(){
            return this.getTotalAmount(this.serviceSalesTally)
        },
        totalServiceSales() {
            return this.getTotalSales(this.serviceSalesTally)
        },
        totalSmogs() {
            return this.getTotalAmount(this.smogSalesTally)
        },
        totalSmogSales() {
            return this.getTotalSales(this.smogSalesTally)
        },
        totalSmogRejects() {
          return "TODO"
        },
        totalSales() {
            return this.totalServiceSales + this.totalSmogSales;
        },
        totalRev() {
            return this.getTotalSales(this.revenue);
        },
        difference() {
            return this.totalRev - this.totalSales;
        },
        shops() {
            return this.$store.state.shops;
        },
        techs() {
            return this.$store.state.techs;
        }
    },
    methods: {
        aggServicesByPrice(dmvTable, transactions) {
            this.resetTable(dmvTable);
            transactions.forEach(t => {
                if (t.service_type !== 'smog') {
                    let service = dmvTable.find(service => service.price === parseInt(t.service_charge));
                    if (service) {
                        service.amount += 1;
                        service.total += service.price;
                    } else {
                        dmvTable.push({ type: 'service', price: t.service_charge, amount: 1});
                    }
                }
            });
        },
        aggServicesByType(serviceTypeTable, transactions) {
            this.resetTable(serviceTypeTable);
            transactions.forEach(t => {
                let service = serviceTypeTable.find(service => service.type === t.service_type);
                if (service) {
                    service.amount += 1;
                }
            });
        },
        aggSmogsByPrice(smogTable, transactions) {
            this.resetTable(smogTable);
            transactions.forEach(t => {
                if (t.service_type === 'Smog') {
                    let smog = smogTable.find(smog => smog.price === parseInt(t.service_charge));
                    if (smog) {
                        smog.amount += 1;
                        smog.total += smog.price;
                    } else {
                        smogTable.push({ type: 'smog', price: t.service_charge, amount: 1});
                    }
                }
            });
        },
        resetTable(table) {
            table.forEach(row => {
                row.amount = 0;
            });
        },
        loadData(transactions) {
            this.aggSmogsByPrice(this.smogSalesTally, transactions);
            this.aggServicesByPrice(this.serviceSalesTally, transactions);
            this.aggServicesByType(this.serviceTypeTally, transactions);
            const payments = this.getPaymentsFromTxns(transactions )
            this.totalCash = payments.cash
            this.totalCC = payments.cc
        },
        formatDateLong(date) {
            const options = {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'};
            return date.toLocaleDateString('en-US', options);
        },
        getTotalSales(table) {
            return table.reduce((acc, row) => acc + (row.price * row.amount), 0)
        },
        getTotalAmount(table) {
            return table.reduce((acc, row) => acc + row.amount, 0)
        },
        getCurrentMonth() {
            const date = new Date();
            return this.formatMonth(date);
        },
        formatMonth(date) {
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = String(date.getFullYear());
            return `${month}/${year}`;
        },
        getEODsSubmitted(date) {
            if (!date) {
                console.log("No date provided to getEODsSubmitted");
                return;
            }
            date = new Date(date);
            date = date.toISOString().split('T')[0];

            axios.get(`${this.baseURL}reports/eods-submitted`, {
                params: {date}
            })
                .then(response => {
                    this.$store.commit('setWhichStoresSubmittedEOD', response.data);
                })
                .catch(error => {
                    console.error(error);
                });
        },
        getEODReport(date, shop_id) {
            const self = this;
            if (!date || !shop_id) {
                console.log("No date or shop_id provided to getEODReport");
                return;
            }
            date = date.toISOString().split('T')[0];

            axios.get(`${this.baseURL}reports/eod`, {
                params: {date, shop_id}
            }).then(response => {
                if (response.status === 404) {
                    console.log("EOD Report not found for the given date and shop ID.");
                    self.clearTable(self.serviceSalesTally);
                    self.clearTable(self.smogSalesTally);
                    self.clearTable(self.serviceTypeTally);
                    self.clearTable(self.revenue);
                    return;
                }
                console.log("EOD Report successfully fetched: ", response.data);
                self.serviceSalesTally = response.data.sales.filter(item => item.type === 'service');
                self.smogSalesTally = response.data.sales.filter(item => item.type === 'smog');
                self.serviceTypeTally = response.data.sales.filter(item => item.type !== 'smog' && item.type !== 'service');
                self.smogRejects = response.data.smog_rejects;
                self.shopId = response.data.shop_id;
                self.techsOnDuty = response.data.techs.map(tech => tech.ID);
                self.revenue = [
                    {type: "ones", label: "$1", price: 1, amount: response.data.ones},
                    {type: "fives", label: "$5", price: 5, amount: response.data.fives},
                    {type: "tens", label: "$10", price: 10, amount: response.data.tens},
                    {type: "twenties", label: "$20", price: 20, amount: response.data.twenties},
                    {type: "fifties", label: "$50", price: 50, amount: response.data.fifties},
                    {type: "hundreds", label: "$100", price: 100, amount: response.data.hundreds},
                    {type: "coins", label: "Change", price: 1, amount: response.data.coins},
                    {type: "cc", label: "CC", price: 1, amount: response.data.cc}
                ];
                self.$store.commit('setEODReport', response.data);
            })
            .catch(error => {
                console.error(error);
            });
        },
        postEODReport(eod, date) {
            const dateToSend = date ?? new Date();
            const data = {
                date: dateToSend.toISOString().split('T')[0],
                eod
            };
            axios.post(`${this.baseURL}reports/eod`, data, {
                headers: {
                    'X-WP-Nonce': localized.nonce
                }
            })
                .then(response => {
                    console.log("EOD Report successfully submitted");
                    this.getEODsSubmitted(date);
                })
                .catch(error => {
                    console.error(error);
                });
        },
        getKPIReport(start_date, end_date, shop_id, tech_id) {

            let start = start_date ?? new Date();
            start.setHours(0, 0, 0, 0); // 00:00:00.000 today
            start.setMinutes(start.getMinutes() + start.getTimezoneOffset()); // Adjust for DB (UTC) discrepancy
            start = this.formatDatForQuery(start);  // YYYY-MM-DD HH:MM:SS format

            let end = end_date ?? new Date(start);
            end.setHours(0,0,0,0);
            end.setMinutes(end.getMinutes() + end.getTimezoneOffset());
            end = this.formatDatForQuery(end);

            axios.get(`${this.baseURL}reports/kpi`, {
                params: {start, end, shop_id, tech_id}
            }).then(response => {
                console.log("KPI Report successfully fetched: ", response.data);
                this.$store.commit('setKPIReport', response.data);
            }).catch(error => {
                console.error(error);
            });
        },
        getSTATReport(start_date, end_date, shop_id, tech_id) {

            let start = start_date ?? new Date();
            start.setHours(0, 0, 0, 0); // 00:00:00.000 today
            start.setMinutes(start.getMinutes() + start.getTimezoneOffset()); // Adjust for DB (UTC) discrepancy
            start = this.formatDatForQuery(start);  // YYYY-MM-DD HH:MM:SS format

            let end = end_date ?? new Date(start);
            end.setHours(0,0,0,0);
            end.setMinutes(end.getMinutes() + end.getTimezoneOffset());
            end = this.formatDatForQuery(end);

            axios.get(`${this.baseURL}reports/stat`, {
                params: {start, end, shop_id, tech_id}
            }).then(response => {
                this.$store.commit('setSTATReport', response.data);
            }).catch(error => {
                console.error(error);
            });
        },
        getPaymentsFromTxns(transactions) {
            let payments = {
                cash: 0,
                cc: 0
            };
            transactions.forEach(t => {
                if (t.cash_or_credit === 'Cash') {
                    payments.cash += t.service_charge;
                } else if (t.cash_or_credit === 'Credit Card') {
                    payments.cc += t.service_charge;
                }
            });
            return payments;
        },
        getDaysOpen(start_date, end_date, shop_id) {
            let start = start_date ?? new Date();
            start.setHours(0, 0, 0, 0); // 00:00:00.000 today
            start.setMinutes(start.getMinutes() + start.getTimezoneOffset()); // Adjust for DB (UTC) discrepancy
            start = this.formatDatForQuery(start);  // YYYY-MM-DD HH:MM:SS format

            let end = end_date ?? new Date(start);
            end.setHours(0,0,0,0);
            end.setMinutes(end.getMinutes() + end.getTimezoneOffset());
            end = this.formatDatForQuery(end);

            axios.get(`${this.baseURL}reports/days-open`, {
                params: {start, end, shop_id}
            }).then(response => {
                this.$store.commit('setDaysOpen', response.data);
            }).catch(error => {
                console.error(error);
            });
        }
    }
};